// extracted by mini-css-extract-plugin
export default {"highlightContainer":"SnippetText_highlightContainer__thP6C","lineClamp1":"SnippetText_lineClamp1__uwqgl"};